<script setup lang="ts">
import { URL_SEARCH } from '@tools/routes/routes';
import IconMagnifyingGlass from '@icons/ph_magnifying-glass.svg';
import { trans } from '@elements/translation.ts';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
</script>

<template>
  <a
    :href="URL_SEARCH"
    :class="[
      'border border-solid border-gray rounded-lg',
      'hover:bg-gray-lighter',
      'w-[190px]',
      'flex items-center gap-2',
      'px-4 py-2',
      'no-underline',
      'hover:shadow-[0_4px_8px_rgb(0_0_0_/_0.25)]'
    ]"
  >
    <Icon
      :svg="IconMagnifyingGlass"
      width="24"
      height="24"
      fill="gray-darker"
    />

    <Typography
      variant="body-bold"
      color="gray-darker"
    >
      {{ trans('user_menu.top.search') }}
    </Typography>
  </a>
</template>
